var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7303 11.0352H16.3956C17.4196 11.0352 18.2497 10.2051 18.2497 9.18117C18.2497 8.15721 17.4196 7.32713 16.3956 7.32713H9.48675C9.50751 7.27672 9.53274 7.22302 9.56214 7.1659C10.1515 6.26147 10.6078 5.09631 10.7898 3.73015C11.0559 1.72574 10.0021 -0.498672 8.17969 0.0988499C7.2698 0.396589 7.44406 1.40874 7.52085 1.85476C7.53162 1.91732 7.54047 1.96874 7.54415 2.00549C7.80544 4.43551 6.70176 5.43269 6.40238 5.70319C6.39056 5.71386 6.38001 5.7234 6.37083 5.73185C6.36583 5.73685 6.36031 5.74211 6.35437 5.74779C6.34094 5.76059 6.3253 5.7755 6.30836 5.79432C4.07037 7.89651 3.38051 8.81995 2.49237 10.55C0.365736 10.6668 -0.0308015 13.0895 0.00179082 15.1347C0.0343828 17.2749 0.333144 18.9181 1.82695 19.1272C2.08194 19.1626 2.40555 19.4163 2.82627 19.7461C3.53483 20.3016 4.51886 21.073 5.91454 21.3815C6.07336 21.4165 6.23815 21.4545 6.40915 21.494C7.92105 21.8434 9.91796 22.3047 12.5609 21.7228H14.03C15.054 21.7228 15.8841 20.8927 15.8841 19.8687C15.8841 19.3173 15.6434 18.8222 15.2614 18.4826H15.2739C16.2979 18.4826 17.128 17.6525 17.128 16.6285C17.128 15.906 16.7148 15.28 16.1117 14.974C17.0935 14.9266 17.8749 14.1156 17.8749 13.1221C17.8749 12.0981 17.0448 11.268 16.0208 11.268H14.7688C14.7565 11.1874 14.7437 11.1098 14.7303 11.0352Z",
    fill: "url(#paint0_linear_4513_2961)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4513_2961",
    x1: 7.48159,
    y1: 7.87614,
    x2: 7.48159,
    y2: 22.8435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDCE4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FDA227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#F7A22E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDA339"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.e90a7f3e421c06d862bd0250146aabea.svg";
export { ForwardRef as ReactComponent };